module.exports = __webpack_public_path__ + "img/login-bg-bottom.0c6e4212.png";